module.exports = __webpack_public_path__ + "static/media/safety.fee6ed0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/safety.svg
// module id = 297
// module chunks = 0